import { defineMessages } from "react-intl";

/**
 * Shared message descriptors for upload helper text (file size limit, supported extensions).
 * Used by upload components across customer app, kyc, kyc-next, funding-application.
 * Only defined here so they are extracted to shared-ui/lang/default.json once.
 */
export const UPLOAD_HELPER_MESSAGES = defineMessages({
  uploadFileSizeLimit: {
    id: "upload file size limit",
    defaultMessage: "Max file size is {sizeLimitMb}MB.",
  },
  supportedFileExtensionUpload: {
    id: "supported file extension upload",
    defaultMessage: "Files supported are {supportedFileExtensions}.",
  },
});
